
import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export const useSiteLogo = () => {
  const [logoUrl, setLogoUrl] = useState<string>('./media/logos/logo_white.png');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogo();
  }, []);

  const fetchLogo = async () => {
    try {
      // Primero intentamos cargar el logo local
      const localLogoUrl = '/media/logos/logo_white.png';
      
      // Verificamos si hay una configuración en Supabase como respaldo
      const { data, error } = await supabase
        .from('site_settings')
        .select('logo_img')
        .limit(1);

      if (error) {
        console.error('Error fetching logo from Supabase:', error);
        setLogoUrl(localLogoUrl);
        return;
      }

      if (data && data.length > 0 && data[0]?.logo_img) {
        // Si hay logo en Supabase, lo guardamos como respaldo
        const { data: { publicUrl } } = supabase.storage
          .from('media')
          .getPublicUrl(data[0].logo_img);
        // El componente intentará usar el logo local primero,
        // y si falla usará este URL de Supabase
        setLogoUrl(publicUrl);
      } else {
        // Si no hay logo en Supabase, mantenemos el local
        setLogoUrl(localLogoUrl);
      }
    } catch (err) {
      console.error('Error:', err);
      setLogoUrl('./media/logos/logo_white.png');
    } finally {
      setLoading(false);
    }
  };

  return { logoUrl, loading, refetch: fetchLogo };
};
